export const MENTOR_SCHEDULE_LINK_GET_REQUEST = 'mentor/schedule-link-get-request'
export const MENTOR_SCHEDULE_LINK_GET_SUCCESS = 'mentor/schedule-link-get-success'
export const MENTOR_SCHEDULE_LINK_GET_FAILED = 'mentor/schedule-link-get-failed'
